<div class="container-fluid px-0">
  <div class="row  mx-0 my-0 h-100">
    <div
      *ngIf="paymentModel != null && user != null && this.paymentInformation?.paymentMethodType ==='DCB' && showReadyLimit"
      class="col-12 px-0 d-flex justify-content-center">
      <div class="info-message">
        <div class="ie">
          <div [ngStyle]="{'width.px': '1259'}"
               class="col-12 px-0 d-flex message-content">
            <span class="message">
              <p
                class="title">{{this.textService.keyValueMapping('whatsInstantLimitHeader', 'Faturana Yansıt Nedir?', user?.sdkInitTexts)}}</p>
              <p>{{this.textService.keyValueMapping('whatsInstantLimitDescription', 'Paycell\'in size sunduğu, Turkcell faturanıza yansıtarak geri ödeyebileceğiniz bir limittir. Ödeme yöntemi olarak Faturana yansıt seçerek alışverişinizi tamamlayıp, fatura döneminizde ödeyebilirsiniz.', user?.sdkInitTexts)}}</p>
            </span>
            <img class="close-logo" [src]="'assets/images/png/ready-limit-close.png'" [srcset]="'assets/images/png/ready-limit-close@2x.png 2x, assets/images/png/ready-limit-close@3x.png 3x'" (click)="readyLimitClose()"
                 alt="logo"/>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="paymentModel != null && user != null && this.paymentInformation?.isSingle === '1' && showBalance"
         class="col-12 px-0 d-flex justify-content-center">
      <div class="info-message">
        <div class="ie">
          <div [ngStyle]="{'width.px': '1259'}"
               class="col-12 px-0 d-flex message-content">
            <span class="message">
              <p
                class="title">{{this.textService.keyValueMapping('whatsRelatedCardHeader', 'Bağlı Paycell Kart Nedir?', user?.sdkInitTexts)}}</p>
              <p>{{this.textService.keyValueMapping('whatsRelatedCardText', 'Paycell hesabınıza bağlı kartınızdır.', user?.sdkInitTexts)}}</p>
            </span>
            <img class="close-logo" [src]="'assets/images/png/ready-limit-close.png'" [srcset]="'assets/images/png/ready-limit-close@2x.png 2x, assets/images/png/ready-limit-close@3x.png 3x'" (click)="balanceClose()"
                 alt="logo"/>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 px-0 d-flex justify-content-center">
      <div *ngIf="message" class="error-message">
        <pa-message [description]="message" [width]="771" (messageState)="messageState($event)"></pa-message>
      </div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="rectangle d-flex px-0" *ngIf="paymentModel != null && user != null">
        <pa-payment-method-selection [paymentModelInformation]="paymentModel" [user]="user"
                                     (carouselChange)="carouselChange($event)" (cvvPassByValue)="cvvPassByValue($event)"
                                     class="col-md-5"></pa-payment-method-selection>
        <div class="col-md-1 px-0">
          <div class="path"></div>
        </div>
        <pa-payment-summary [paymentInformation]="paymentInformation" [paymentModelInformation]="paymentModel"
                            [user]="user" [paymentCvv]="this.cvv" (errorMessage)="messageState($event)"
                            class="col-md-6 px-0"></pa-payment-summary>
      </div>
    </div>
  </div>
</div>
